import { createRoot } from 'react-dom/client'
import { useState, useEffect } from 'react'
import './styles.css'
import App from './App'

function Overlay() {
  const [time, setTime] = useState(new Date())
  
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])
  
  return (
    <div className="overlay">
      {/* Top left corner - REMOVED: Now handled by UnifiedSideMenu in App.js */}
      
      {/* Top right corner - Time and coordinates */}
      <div className="panel top-right">
        <div className="info-line">
          <span className="label">LA (UTC-8)</span>
          <span className="value cyan">{time.toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
        </div>
        <div className="info-line">
          <span className="label">TOKYO (UTC+9)</span>
          <span className="value magenta">{time.toLocaleTimeString('en-US', { timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
        </div>
        <div className="info-line">
          <span className="label">YEAR</span>
          <span className="value">2045</span>
        </div>
        <div className="info-line">
          <span className="label">PORTAL</span>
          <span className="value">LA ⟷ TK</span>
        </div>
      </div>
      
      {/* Bottom left corner - Team info */}
      <div className="panel bottom-left">
        <div className="team-info">
          <div className="team cyan-glow">
            <div className="team-label">TEAM A</div>
            <div className="team-location">LA</div>
            <div className="team-shapes">12 SHAPES DEPLOYED</div>
          </div>
          <div className="team magenta-glow">
            <div className="team-label">TEAM B</div>
            <div className="team-location">TOKYO</div>
            <div className="team-shapes">12 SHAPES DEPLOYED</div>
          </div>
        </div>
      </div>
      
      {/* Bottom right corner - Technical info */}
      <div className="panel bottom-right">
        <div className="tech-info">
          <div className="tech-line">
            <span className="dot cyan-bg"></span>
            <span>WHEN ALL ELSE FAILS, AI DECIDES</span>
          </div>
          <div className="tech-line">
            <span className="dot magenta-bg"></span>
            <span>PORTAL ACTIVE</span>
          </div>
          <div className="tech-line">
            <span className="dot cyan-bg"></span>
            <span>DRONE ARRAY CONNECTED</span>
          </div>
          <div className="tech-line">
            <span className="dot cyan-bg"></span>
            <span>2D IS DEAD!</span>
          </div>
        </div>
        <div className="copyright">© 2045 HALF LEAGUE</div>
      </div>
      
      {/* Center bottom - Instructions */}
      <div className="panel center-bottom">
        <div className="instructions">
          <span className="key">DRAG</span> Rotate
          <span className="separator">•</span>
          <span className="key">RIGHT-DRAG</span> Pan
          <span className="separator">•</span>
          <span className="key">SCROLL</span> Zoom
        </div>
      </div>
      
      {/* Decorative corner brackets */}
      <div className="corner-bracket top-left-bracket"></div>
      <div className="corner-bracket top-right-bracket"></div>
      <div className="corner-bracket bottom-left-bracket"></div>
      <div className="corner-bracket bottom-right-bracket"></div>
      
      {/* Scanline overlay */}
      <div className="scanline"></div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <>
    <App />
    <Overlay />
  </>
)

